import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteNotarioDePredio,
  getNotariosPredios,
  patchNotarioDePredio,
  postNotarioDePredio,
} from 'api/catastro/notariosDePredios';
import { baseURI, getContribuyentes } from 'api/empresas/contribuyentes';
import { generatePhoneRules } from 'utils/rules';

export const permissionConfig = {
  permissionModel: 'notario_catastro',
  required: ['view_contribuyente'],
};

// eslint-disable-next-line react/prop-types
const NotariosPredios = ({ permission, addressPermission }) => (
  <PlainCRUD
    title="Notarios"
    permission={permission}
    get={getNotariosPredios}
    post={postNotarioDePredio}
    patch={patchNotarioDePredio}
    delete={deleteNotarioDePredio}
    withoutState
    fields={[
      {
        ...defaultFields.clave,
        disabled: true,
        required: false,
        colWidth: 120,
      },
      {
        name: 'nombre_completo',
        label: 'Nombre completo',
        colWidth: 200,
        tableOnly: true,
      },
      {
        name: 'nombre',
        label: 'Nombre',
        required: true,
      },
      {
        name: 'apellido_paterno',
        label: 'Apellido Paterno',
        required: true,
      },
      {
        name: 'apellido_materno',
        label: 'Apellido Materno',
      },
      {
        name: 'numero_notaria',
        label: 'Número de notaria',
        required: true,
        colWidth: 150,
      },
      {
        name: 'puesto',
        label: 'Puesto',
      },
      {
        name: 'telefono_celular',
        lada: 'lada_celular',
        label: 'Teléfono',
        type: 'phone',
        rules: generatePhoneRules({
          required: false,
          label: 'Perito',
          getter: getContribuyentes,
          validateUnique: true,
        }),
      },
    ]}
    paginated
    addressPermission={addressPermission}
    baseURI={baseURI}
    address={{ name: 'direcciones' }}
    valuesFormatter={(values) => ({
      ...values,
      nombre_completo: ['nombre', 'apellido_paterno', 'apellido_materno']
        .map((f) => values[f] || '').filter((e) => e).join(' ').trim(),
    })}
  />
);

export default NotariosPredios;
